import { render, staticRenderFns } from "./MassActionDropdown.vue?vue&type=template&id=4135756e&scoped=true"
import script from "./MassActionDropdown.vue?vue&type=script&lang=js"
export * from "./MassActionDropdown.vue?vue&type=script&lang=js"
import style0 from "./MassActionDropdown.vue?vue&type=style&index=0&id=4135756e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135756e",
  null
  
)

export default component.exports